export default __webpack_public_path__ + "static/media/games-banner-cn.b658421b.webp";